import { useCallback, useState } from 'react'
import { useFocusEffect } from 'expo-router'
import { useApiClient } from '../../../helpers/apiClient.helper'
import { API_ENDPOINTS } from '../../../constants/api'

interface AccessEnvelope {
  success?: boolean
  data?: { isZportiAdmin?: boolean; isImpersonating?: boolean }
}

/**
 * Loads whether the signed-in user is a Zporti operator (admin) via GET /admin/b2b/access.
 */
export function useZportiAdminAccess() {
  const apiClient = useApiClient()
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const res = await apiClient<AccessEnvelope>(API_ENDPOINTS.zportiAdmin.access)
      setIsAdmin(Boolean(res.data?.data?.isZportiAdmin))
    } catch {
      setIsAdmin(false)
    } finally {
      setLoading(false)
    }
  }, [apiClient])

  useFocusEffect(
    useCallback(() => {
      void load()
    }, [load]),
  )

  return { isAdmin, loading, reload: load }
}
